module.exports = __webpack_public_path__ + "img/predict.fb10ec20.svg";